'usr strict';

import controller from './techos_presupuestarios.controller';
import template from './techos_presupuestarios.html';

const TechosPresupuestariosComponent = {
  bindings: {},
  controller,
  template
};

export default TechosPresupuestariosComponent;



// WEBPACK FOOTER //
// ./src/app/components/admin/techos_presupuestarios/techos_presupuestarios.component.js